/**
 * Channel switch: CHILL <-> NSFW. Mirrors the original animated pill toggle
 * but restyled into the new top bar.
 */
export function ChannelToggle({ isChill, onToggle }) {
  return (
    <div class={`channel ${isChill ? 'channel--chill' : 'channel--nsfw'}`}>
      <span class="channel__label">
        <span aria-hidden="true">✨</span>
        <span class="channel__label-text">CHILL</span>
      </span>
      <button
        type="button"
        class={`channel__switch ${isChill ? 'channel__switch--chill' : 'channel__switch--nsfw'}`}
        role="switch"
        aria-checked={!isChill}
        aria-label="Toggle content channel"
        onClick={onToggle}
      >
        <span class="channel__knob" />
      </button>
      <span class="channel__label">
        <span aria-hidden="true">🌶️</span>
        <span class="channel__label-text">NSFW</span>
      </span>
    </div>
  );
}
